define('views/conversations/Podio.Views.Conversations.Message',['require','underscore','jquery','lib/backbone/Backbone.PodioView','views/files/Podio.Views.Files.CompactFile','views/embeds/Podio.Views.Embeds.Embed','lib/view_helpers/markdown','lib/Podio.Config','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var CompactFileView = require('views/files/Podio.Views.Files.CompactFile');
  var EmbedView = require('views/embeds/Podio.Views.Embeds.Embed');

  var markdownHelper = require('lib/view_helpers/markdown');
  var podioConfig = require('lib/Podio.Config');
  var podioUtils = require('lib/Podio.Utils');


  return ViewPodioBase.extend({
    tagName: 'li',
    className: 'message',

    podioEvents: {
    },

    initialize: function(options) {
      this._super();
      this.files = this.model.getFilesCollection();
      this.embed = this.model.getEmbed();
      this.embedFile = this.model.getEmbedFile();
    },

    render: function() {
      var markdown = markdownHelper.formatMarkdown(this.model.get('data').text);

      this.model.set('markdown', markdown);

      // Render message text
      this.elm.html(this.getTemplate(this.options.template, {
        conversationEvent: this.model,
        fresh: this.options.fresh,
        coalesce: this.options.coalesce,
        showBinIcon: podioUtils.showFeature('conversation_message_delete'),
        messageByCurrentUser: podioConfig.user.user_id === this.model.get('created_by').get('id'),
        translations: {
          deleteComment: t('Delete message #conversation'),
          editComment: t('Edit comment #stream.activity'),
        }
      }));
      this.elmMessage = this.elm.find('.message');

      // Render files
      if (this.files.length > 0) {
        var elmFiles = $('<div/>').addClass('files');

        var noThumbnails = this.files.filter(function(file) { return _.isEmpty(file.get('thumbnail_link')); });
        var withThumbnails = this.files.filter(function(file) { return !_.isEmpty(file.get('thumbnail_link')); });

        _.each({'non-image-files': noThumbnails, 'image-files': withThumbnails}, function(files, type) {
          if (_.any(files)) {
            var elmTypeContainer = $('<div/>').addClass(type + '-container');

            _.each(files, function(file) {
              this.renderFile(file, elmTypeContainer);
            }, this);

            elmFiles.append(elmTypeContainer);
          }
        }, this);

        this.elmMessage.append(elmFiles);
      }

      if (this.embed) {
        this.renderEmbed(this.embed, this.embedFile, this.elmMessage);
      }

      return this;
    },

    markAsStale: function() {
      this.elm.find('> div').removeClass('fresh');
    },

    renderFile: function(file, elmFiles) {
      var fileView = new CompactFileView({
        model: file,
        canDelete: false,
        reference: this.model
      });
      fileView.render();
      elmFiles.append(fileView.el);
    },

    renderEmbed: function(embed, embedFile, elmMessage) {
      var embedView = new EmbedView({
        model: embed,
        embedFile: embedFile
      });
      embedView.render();
      elmMessage.append(embedView.el);
    }

  });

});

